import React, { useMemo, useEffect } from 'react';
import InvitationRequests from '@medflex/components/stories/InvitationRequests/InvitationRequests';
import useIsFocused from '@medflex/hooks/useIsFocused';
import config from '@medflex/utils/config';
import useInvitationRequests from '../hooks/useInvitationRequests';
import useUserProfile from '../hooks/useUserProfile';
import usePermissions from '../hooks/usePermissions';

const InvitationRequestsModule = () => {
  const {
    invitationRequests: patientInvitationRequests,
    invite,
    ignore,
    setIsSeen,
  } = useInvitationRequests();
  const { userProfile, isLoadingUserProfile } = useUserProfile();
  const { hasPatientAccess } = usePermissions();
  const focused = useIsFocused();

  const pagesLink = useMemo(() => {
    if (!isLoadingUserProfile && userProfile) {
      const { slugWithId } = userProfile.attributes;
      return `${config.PHYSICIAN_PAGES_URL}/${slugWithId}`;
    }
    return null;
  }, [userProfile, isLoadingUserProfile]);

  useEffect(() => {
    if (
      patientInvitationRequests.length > 0 &&
      patientInvitationRequests.filter(({ seen }) => !seen).length > 0 &&
      focused
    ) {
      const timeout = setTimeout(() => {
        setIsSeen();
      }, 5000);
      return () => {
        clearTimeout(timeout);
      };
    }
    return undefined;
  }, [focused, patientInvitationRequests]);

  return (
    <div data-component="InvitationRequests" className="flex flex-auto h-full w-full">
      <InvitationRequests
        patientInvitationRequests={patientInvitationRequests}
        onInvitePatient={invite}
        onDeletePatientInvitationRequest={ignore}
        pagesLink={pagesLink}
        showPatientInvitationRequests={hasPatientAccess}
      />
    </div>
  );
};

export default InvitationRequestsModule;
